import { render, staticRenderFns } from "./ImportLeader.vue?vue&type=template&id=6dcc76e0&scoped=true&"
import script from "./ImportLeader.vue?vue&type=script&lang=js&"
export * from "./ImportLeader.vue?vue&type=script&lang=js&"
import style0 from "./ImportLeader.vue?vue&type=style&index=0&id=6dcc76e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc76e0",
  null
  
)

export default component.exports